/*
    StripeProvider.jsx
    Stripe Elements Provider for NPO Donation System
    サンタナム リシ
*/

import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// Load Stripe with your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const StripeProvider = ({ children, clientSecret, amount, currency = 'jpy', locale = 'ja' }) => {
    const options = {
        clientSecret,
        locale: locale, // Set the language for Stripe Elements
        appearance: {
            theme: 'stripe', // Use stripe base theme for better compatibility
            variables: {
                // Keep it simple - only the most important customizations
                colorPrimary: '#F89263', // Your brand orange
                colorBackground: '#ffffff',
                colorText: '#4E342E', // Your dark brown text
                colorDanger: '#F87581', // Your accent pink for errors
                fontFamily: 'DotGothic16, system-ui, sans-serif', // Your font
                spacingUnit: '4px',
                borderRadius: '12px' // Match your card radius
            }
            // Remove the complex rules - let Stripe handle the layout
        }
    };

    return (
        <Elements stripe={stripePromise} options={clientSecret ? options : undefined}>
            {clientSecret ? children : <div>決済の準備中...</div>}
        </Elements>
    );
};

export default StripeProvider;
